import * as Scrivito from 'scrivito';
import { LinkWidgetAttributes } from './link-widget-definitions';
import { LinkWidgetClass } from './link-widget-class';
import { LinkComponent } from '../../components/building-blocks/link/link';

Scrivito.provideComponent(LinkWidgetClass, ({ widget }) => {
  const title = widget.get(LinkWidgetAttributes.TITLE) as string;
  const link = widget.get(LinkWidgetAttributes.LINK) as Scrivito.Link;
  const accessibilityText = widget.get(LinkWidgetAttributes.ACCESSIBILITY_TEXT) as string;

  return <LinkComponent title={title} to={link} accessibilityText={accessibilityText} />;
});
